import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { reviews, villaStats } from '../data/mockData';
import { useLanguage } from '../contexts/LanguageContext';

export const Reviews = () => {
  const { t } = useLanguage();

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star
        key={index}
        className={`h-4 w-4 ${index < rating ? 'star-filled' : 'star-empty'}`}
        fill={index < rating ? 'currentColor' : 'none'}
      />
    ));
  };

  return (
    <section className="reviews-section">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="section-badge">{t('reviewsSection.badge')}</div>
          <h2 className="section-title">{t('reviewsSection.title')}</h2>

          <div className="overall-rating">
            <div className="rating-stars">
              {renderStars(5)}
            </div>
            <span className="rating-score">{villaStats.rating} / 5.0</span>
            <span className="rating-count">
              {t('reviewsSection.basedOn').replace('{n}', villaStats.reviewCount)}
            </span>
          </div>
        </div>

        <div className="reviews-grid">
          {reviews.map((review, index) => (
            <Card key={index} className="review-card">
              <CardContent className="review-card-content">
                <Quote className="review-quote-icon" />
                <div className="review-stars">
                  {renderStars(review.rating)}
                </div>
                <p className="review-text">"{review.text}"</p>
                <div className="review-author">
                  <div className="author-avatar">{review.name.charAt(0)}</div>
                  <div className="author-info">
                    <span className="author-name">{review.name}</span>
                    <span className="author-meta">{review.country} • {review.date}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
